import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  selector: '[ngInit]'
})
export class InitDirective {
  @Input() isLast: boolean;

  @Output('ngInit') initEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }
  ngOnInit() {
    if (this.isLast) {
      setTimeout(() => this.initEvent.emit(), 10);
    }
  }

}
